import React, { useEffect, useState } from 'react';
import { Link } from 'react-router';
import AttachmentIcon from 'material-ui/svg-icons/file/attachment';
import { fromUTC } from 'helpers/dates';
import LetterCondition from './LetterCondition';

const LetterItem = ({ item }) => {
    const [currentItem, setCurrentItem] = useState(item);

    useEffect(() => {
        setCurrentItem(item);
    }, [item]);

    let backgroundColor = 'collection-item';
    const hasAttachment = currentItem.attachArr && currentItem.attachArr.length;

    switch (currentItem.type) {
    case 'cargo':
        backgroundColor = 'cargo collection-item';
        break;
    case 'vessel':
        backgroundColor = 'vessel collection-item';
        break;
    }

    if (currentItem.eh === 'fix') {
        backgroundColor = 'fix collection-item';
    } else if (currentItem.eh === 'fixture') {
        backgroundColor = 'fixture collection-item';
    }

    return (
        <li className={backgroundColor}>
            <div className='column'>
                {
                    currentItem.eh === 'fix'
                        ? (<div className='inner-item'>
                            <span className='title'>FIX:</span>
                        </div>)
                        : null
                }
                <div className='inner-item'>
                    <span className='title'>SUBJECT:</span> { currentItem.subject }
                </div>
                <div className='inner-item'>
                    <span className='title'>SENDER NAME:</span>  { currentItem.sender[0].name }
                </div>
                <div className='inner-item'>
                    <span className='title'>DATE:</span>  { fromUTC(currentItem.date).toLocaleString() }
                </div>
                {
                    currentItem.processingCondition && currentItem.processingCondition[currentItem.processingCondition.length - 1] ?
                        <div className='inner-item' style={{ display: 'flex', alignItems: 'center' }}>
                            <span className='title'>PROCESSING:</span>  
                            <LetterCondition processingCondition={currentItem.processingCondition[currentItem.processingCondition.length - 1]} />
                        </div>
                        : null
                }
            </div>

            <div className='column'>
                <div className='inner-item'>
                    <span className='title'>refNo:</span> { currentItem.refNo }
                </div>
                <div className='inner-item'>
                    <span className='title'>TYPE:</span> { currentItem.type }
                </div>
                <div className='inner-item'>
                    <span className='title'>LAST OPENED:</span>  { new Date(currentItem.lastModify.date).toLocaleString() }
                </div>
                <div className='inner-item'>
                    <span className='title'>BY USER:</span>  { currentItem.lastModify.user ? currentItem.lastModify.user.email : '' }
                </div>

                {
                    !!hasAttachment && (
                        <div className='inner-item'>
                            <span className='title'>
                                Attachments <AttachmentIcon color="white" style={{ verticalAlign: 'bottom' }} />:
                            </span>
                            &nbsp;
                            { currentItem.attachArr.length }
                        </div>
                    )
                }
            </div>

            <div className='column'>
                <Link to={currentItem._id} target='_blank'>GAZETTER</Link>
                <Link to={`${currentItem._id}/annotator/vessel`} target='_blank'>VESSEL</Link>
                <Link to={`${currentItem._id}/size/vessel`} target='_blank'>VESSEL SIZE</Link>
                <Link to={`${currentItem._id}/sales`} target='_blank'>VESSEL SALES</Link>
                <Link to={`${currentItem._id}/annotator/cargo`} target='_blank'>CARGO</Link>
                <Link to={`${currentItem._id}/annotator/tc`} target='_blank'>TC</Link>
                {/* <Link to={`${currentItem._id}/annotator/hire`} target='_blank'>HIRE</Link> */}
                <Link to={`${currentItem._id}/train`} target='_blank'>TRAIN</Link>
            </div>
        </li>
    );
};

export default LetterItem;



// WEBPACK FOOTER //
// ./app/components/Letters/List/Item.jsx